import { render } from "./Tag.vue?vue&type=template&id=579c06f9&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=579c06f9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-579c06f9"

export default script